/**
 * /app/$tenantSlug/interviews — Inbox → Interviews (nav-build spec C): the
 * rounds the signed-in person is interviewing on, with the feedback they
 * owe. A thin route over the existing "My interviews" component
 * (components/hiring/interviews-tab.tsx, GET /hiring/interviews/mine —
 * interviewer-scoped server-side); each round's pill is date-aware
 * (Scheduled → Feedback Due → Feedback Overdue → Feedback Given). Rounds
 * with nothing left to do sit under a collapsed "Done".
 *
 * ?interview=<id> brings one round into view (the bell's "new interview"
 * link; an old /hiring/interviews?interview=<id> link redirects here —
 * /hiring/interviews is now the company-wide schedule).
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { InboxPage } from "@/components/inbox/inbox-page";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { InterviewsTab } from "@/components/hiring/interviews-tab";

const searchSchema = z.object({
  interview: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute("/_authgated/app/$tenantSlug/interviews")({
  validateSearch: searchSchema,
  component: InterviewsRoute,
});

function InterviewsRoute() {
  const { interview } = Route.useSearch();
  return (
    <InboxPage
      title="Interviews"
      description="Rounds you're interviewing on. Open the résumé before each one and give feedback after it."
    >
      <HiringFeatureGate>
        <InterviewsTab focusId={interview} inbox />
      </HiringFeatureGate>
    </InboxPage>
  );
}
